<audio :src="audio" ref="audioElement" :onloadeddata="play"></audio>